export default __webpack_public_path__ + "static/grid-types-dark-8f830643c6b57b621e29eb464488d5d628070d698c58e38a928a57d22f4804e1.png";